import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppState } from 'src/redux/modules';
import AboutFundraiser from 'src/components/AboutFundraiser/AboutFundraiser';
import { addCensure } from 'src/redux/modules/censures';
import {
  setRecaptcha,
  clearRecaptcha,
  closeContactOwner,
  openContactOwner,
  contactOwner,
} from 'src/redux/modules/page';

interface StateProps {
  id: string;
  location?: string;
  isContactingOwnerWindowOpen: boolean;
  ownerBio?: string;
  ownerName: string;
  profileImage?: string;
  recaptcha: string;
}

interface DispatchProps {
  addCensure: () => void;
  clearRecaptcha: () => void;
  closeContactOwner: () => void;
  contactOwner: (
    data: { id: string; recaptcha: string; subject: string; message: string }
  ) => void;
  openContactOwner: () => void;

  setRecaptcha: (response: string) => void;
}

function mapStateToProps(state: AppState): StateProps {
  return {
    id: state.page.id,
    location: state.page.locationText,
    isContactingOwnerWindowOpen: state.page.isContactingOwnerWindowOpen,
    ownerBio: state.page.ownerBio,
    ownerName: state.page.ownerName,
    profileImage: state.page.ownerProfileImageUrl,
    recaptcha: state.page.recaptcha,
  };
}

function mapDispatchToProps(dispatch: any): DispatchProps {
  return bindActionCreators(
    {
      addCensure,
      clearRecaptcha,
      setRecaptcha,
      closeContactOwner,
      openContactOwner,
      contactOwner,
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AboutFundraiser);



// WEBPACK FOOTER //
// ./src/containers/page/AboutFundraiserContainer.tsx